module.exports = __webpack_public_path__ + "img/bottom3.403fce8d.png";